import React, { useEffect } from 'react';

import UserPersonalDetailsGeneralForm from './UserPersonalDetailsGeneralForm';
import UserPersonalDetailsSecurityForm from './UserPersonalDetailsSecurityForm';
import UserRegionalSettingsForm from './UserRegionalSettingsForm';

import useApiRequest from 'Hooks/useApiRequest';

export default function UserPersonalDetails(props) {
    useEffect(() => {
        fetchUserRequest.get();
    }, []);

    const fetchUserRequest = useApiRequest({ url: props.fetchUrl });
    const updateProfileRequest = useApiRequest({ url: props.updateProfileUrl });
    const updateRegionalSettingsRequest = useApiRequest({ url: props.updateRegionalSettingsUrl });

    const user = fetchUserRequest.data || props.userDetails;

    const updateProfile = async (data) => {
        updateProfileRequest.put(data).then((response) => {
            fetchUserRequest.get();
        });
    };

    const updateRegionalSettings = async (data) => {
        updateRegionalSettingsRequest.put(data).then((response) => {
            fetchUserRequest.get();
        });
    };

    return (
        <div>
            <div className="row">
                <div className="col-6">{Object.keys(user).length > 0 && <UserPersonalDetailsGeneralForm user={user} updateProfile={updateProfile} />}</div>
                <div className="col-6">
                    <UserPersonalDetailsSecurityForm changePasswordUrl={props.changePasswordUrl} />
                </div>
                <div className="col-6 mt-4">
                    {Object.keys(user).length > 0 && <UserRegionalSettingsForm user={user} updateRegionalSettings={updateRegionalSettings} />}
                </div>
            </div>
        </div>
    );
}
